import {Controller} from "@/controllers/Controller";

/**
 * Controller for the super admin space API : the groups (users, connections, options) and their options (ms-auth, /user/admin),
 * and the containers with the audience of the fronts (the API gateway, /gateway/admin)
 */
export class AdministrationController extends Controller {

    static getOverview() {
        return this.requestBuilder("GET", `/user/admin/overview`, true);
    }

    // urlParams : the table params (?filters=&sort=&index=&pages=)
    static getGroups(urlParams = "") {
        return this.requestBuilder("GET", `/user/admin/groups${urlParams}`, true);
    }

    static getGroup(groupId) {
        return this.requestBuilder("GET", `/user/admin/groups/${groupId}`, true);
    }

    // The containers (micro services) : state, memory, cpu, disks, database and usage
    static getContainers() {
        return this.requestBuilder("GET", `/gateway/admin/containers`, true);
    }

    // Memory and cpu of all the containers over time. range : 1h, 6h, 24h, 7d or 30d
    static getContainersHistory(range = "") {
        return this.requestBuilder("GET", `/gateway/admin/containers/history${this.query({range})}`, true);
    }

    static getContainer(containerId) {
        return this.requestBuilder("GET", `/gateway/admin/containers/${containerId}`, true);
    }

    // params : {level, search, limit}, the empty ones are ignored
    static getContainerLogs(containerId, params = {}) {
        return this.requestBuilder("GET", `/gateway/admin/containers/${containerId}/logs${this.query(params)}`, true);
    }

    // What a container did (mails sent, documents generated...) : params {type, status, limit}, the empty ones are ignored
    static getContainerActivity(containerId, params = {}) {
        return this.requestBuilder("GET", `/gateway/admin/containers/${containerId}/activity${this.query(params)}`, true);
    }

    // Audience of a front (app : the audience of its container, business, website, oufleurcrea...) : visits, visitors, devices, hours... range : 24h, 7d, 30d or 90d
    static getAnalytics(app, range = "") {
        return this.requestBuilder("GET", `/gateway/admin/analytics${this.query({app, range})}`, true);
    }

    // "?a=1&b=2" without the empty params, "" when there is none
    static query(params) {
        const query = new URLSearchParams(Object.entries(params).filter(([, value]) => value !== '' && value !== undefined && value !== null)).toString();
        return query ? `?${query}` : '';
    }

    // Deletes the group and everything that belongs to it (users, contracts, purchases...) : irreversible
    static deleteGroup(groupId) {
        return this.requestBuilder("DELETE", `/user/admin/groups/${groupId}`, true);
    }

    static addOption(groupId, name) {
        return this.requestBuilder("POST", `/user/admin/groups/${groupId}/options`, true, {name: name});
    }

    static removeOption(groupId, name) {
        return this.requestBuilder("DELETE", `/user/admin/groups/${groupId}/options/${encodeURIComponent(name)}`, true);
    }

}
